<template>
  <Card title="setting.reminder_config" containerClass="mb-5">
    <template #cardBody>
      <InfoAlert :text="$t('setting.reminder_config_text')"/>
      <div class="d-flex justify-content-center">
        <RequiredText />
      </div>
      <div class="row">
        <div  
          class="col-md-6 col-12"
          v-for="(config, index) in contextEnum"
          :key="index"
        >
          <ConfigForm
            :id="config.name" 
            :title="config[locale]"
            :isLoading="formData[index].loading" 
            :form="formData[index]"
            @submit="configSubmit(config.name, index)"
          ></ConfigForm>
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import {ref, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import ConfigForm from "./ConfigForm.vue";
import { useLocales } from "@/composables/locales";
import InfoAlert from "@/components/InfoAlert"
import RequiredText from "@/components/RequiredText"

const {locale} = useLocales()
const store = useStore()

const formData = ref([
  {
    frequency: '',
    frequency_count: '',
    context: '',
    loading: false
  },
  {
    frequency: '',
    frequency_count: '',
    context: '',
    loading: false
  }
])

const contextEnum = computed(() => store.getters["configs/getContextEnum"])

onMounted(() => {
  store.dispatch('configs/loadContextEnum')
})

function configSubmit(name, index){
  formData.value.context = name
  formData.value[index].loading = true
    store.dispatch('configs/configFrequency', formData.value[index])
        .then((response) => {
          window.toastr['success'](i18n.global.t('notification.config_frequency'))
        })
        .catch(err => {
        }).finally(() => {
          formData.value[index].loading = false
        })
}
</script>

